import request from '.././utils/request.js'
import colorUtil from '@/utils/colorUtil'
import toast from '@/utils/toast'
import config from '@/assets/js/config'
import logger from '@/utils/logger'

var auth_api = {
    get_auth:()=>{
		
        if(config.anonymousAuth){
            return "{\"accessToken\":\"eyJhbGciOiJIUzUxMiJ9.eyJ1c2VyX2lkIjozOTEsInVzZXJfa2V5IjoiMDlkZDRkOTgtYjZkYS00Zjk2LTkwNDItODcwNzY0Nzk2YjAxIiwidXNlcm5hbWUiOiJqekBqemtqZ3JvdXAuY29tIn0.XJyAYmjqvZz3lyJ_bESMgod8dbvn7cMQsYLQ25CdCsJn-GRWSDTVPyo40wup6mzyYQCHv1ZP2Bq3VxwOctM0MQ\",\"host\":\"\"}"
        } else {
			var userAgent = navigator.userAgent;
			if (/miniProgram/i.test(userAgent) && /micromessenger/i.test(userAgent)&&window.miniImsp) {
				return JSON.stringify({
					refreshToken:false,
					accessToken:window.miniImsp.token,
					host:window.miniImsp.requestUrl,
				})
			}else{
				return window.android.getAuth();
			}
        }
    },
    set_auth:(ip,access_token,refresh_token)=>{
        // logger.i('#wb# save->'+ip+',access='+access_token+",refresh="+refresh_token);
        if(!config.anonymousAuth){
            window.android&&window.android.setAuth(ip,access_token,refresh_token);
        }
    },
    get_auth_params:()=>{
        if(config.anonymousAuth) {
            return "{\"identifier\":\"abc\",\"certificate\":\"1123324\"}"
        } else {
            return window.android?window.android.getAuthParams():"{\"identifier\":\"abc\",\"certificate\":\"1123324\"}";
        } 
    }
}

export {auth_api}

var Config = {
    ip:'localhost',
    port: 81,
    remote(){
        if(!config.anonymousAuth){
			var userAgent = navigator.userAgent;
			if (/miniProgram/i.test(userAgent) && /micromessenger/i.test(userAgent)&&window.miniImsp) {
				return window.miniImsp.requestUrl
			}else{
				return window.android.getBaseUrl();
			}
        }
        return 'http://'+this.ip+':'+this.port+'/api';
    }
}
export {Config}

const URL = {
    /**登陆 */
    Login:'/Login',
    /**获取设备列表 */
    GetDeviceList:'/DeviceManage/GetDeviceList',
    /**获取单设备信息 */
    GetSingleDeviceInfo:'/DeviceManage/GetSingleDeviceInfo',
    /**重命名设备 */
    RenameDevice:'/DeviceManage/RenameDevice',
    /**获取所有场景信息 */
    GetAllSceneInfo:'/Scene/GetAllSceneInfo',
	/*获取某个区域场景信息 edit*/
	GetSceneListByRoomID:'/api-smart/scene/binding/list',
    /**创建场景 */
    CreateScene:'/Scene/CreateScene',
    /**删除场景 */
    DeleteScene:'/Scene/DeleteScene',
    /**重命名场景 */
    RenameScene:'/Scene/ReanmeScene',
    /**场景添加子设备 */
    SceneAddSubDevice:'/Scene/AddSubDevice',
    /**场景删除子设备 */
    SceneRemoveSubDevice:'/Scene/DeleteSubDevice',
    /**场景修改子设备 */
    SceneUpdateSubDevice:'/Scene/ModifySubDevice',
    /**场景绑定到面板 */
    SceneBind:'/Scene/BindScene',
    
    /**获取场景设备列表 */
    SceneDeviceList:'/Scene/GetDeviceListBySceneID',
    /**获取场景设备信息 */
    SceneDeviceInfo:'/Scene/GetSceneInfoBySceneID',

    /**新增接口 */
    /**设备属性写操作 edit */
    DevicePropertiesSet:'/api-device/device/set/property',
    /**设备属性读操作 */
    DevicePropertiesGet:'/DeviceProperties/Get',
	 /**设备详情操作 */
	DeviceDetail:'/api-device/device',
    /**设备重置 */
    DeviceReset:'/DeviceManage/ResetDevice',
	
	// 025a start
	/**获取炫彩情景分类数据*/
	DreamLightCategoriesUrl:'/api-bling/dream-light/categories/data',
	/**获取炫彩情景模式列表*/
	DreamLightMode:'/api-bling/dream-light/modes',
	/**添加炫彩情景*/
	DreamLightAddUrl:'/api-bling/dream-light/add',
	/**删除炫彩情景*/
	DreamLightRemUrl:'/api-bling/dream-light/rem',
	/**修改炫彩情景*/
	DreamLightUptUrl:'/api-bling/dream-light/info/upt',
	// 025a end
	
	
	
	// 041b Start
	DreamLightCategoriesUrlV2:'api-bling/dream-light/v2/categories/data',
	/**获取炫彩情景模式列表*/
	DreamLightModeV2:'/api-bling/dream-light/modes',
	/**添加炫彩情景*/
	DreamLightAddUrlV2:'/api-bling/dream-light/v2/add',
	/**删除炫彩情景*/
	DreamLightRemUrlV2:'/api-bling/dream-light/rem',
	/**修改炫彩情景*/
	DreamLightUptUrlV2:'/api-bling/dream-light/v2/info/upt',
	
	
	
	//041b end
	// spl-022ct Start
	DreamLightCategoriesUrlV3:'/api-bling/dream-light/v3/categories/data',
	/**获取炫彩情景模式列表*/
	DreamLightModeV3:'/api-bling/dream-light/modes',
	/**添加炫彩情景*/
	DreamLightAddUrlV3:'/api-bling/dream-light/v3/post',
	/**删除炫彩情景*/
	DreamLightRemUrlV3:'/api-bling/dream-light/rem',
	/**修改炫彩情景*/
	DreamLightUptUrlV3:'/api-bling/dream-light/v3/info/upt',
	
	// spl-022ct Start
	DreamLightCategoriesUrlV3:'/api-bling/dream-light/v3/categories/data',
	/**获取炫彩情景模式列表*/
	DreamLightModeV3:'/api-bling/dream-light/modes',
	/**添加炫彩情景*/
	DreamLightAddUrlV3:'/api-bling/dream-light/v3/post',
	/**删除炫彩情景*/
	DreamLightRemUrlV3:'/api-bling/dream-light/rem',
	/**修改炫彩情景*/
	DreamLightUptUrlV3:'/api-bling/dream-light/v3/info/upt',

	//spl-022ct end
	
	// 036 start
	/**查询设备绑定场景*/
	queryBindRuleUrl:'/api-device/deviceRule/queryBindRule',
	// 绑定场景
	bindRuleUrl:'api-device/deviceRule/bindRule',
	// 解绑场景
	unBindRuleUrl:'/api-device/deviceRule/unBindRule',
	/**场景执行 edit */
	SceneExecute:'/api-smart/scene/exec',
	//编辑别名
	editNameUrl:"/api-device/thing/properties/alias",
	//语言设置
	setLanguage:"/system/exp/client/language/change",
	//获取某个项目下的区域列表
	getAreaURL:'/system/area/'
}

const Api = {
    getArea(data){
		return request({
			baseURL:Config.remote(),
		    url:URL.getAreaURL+data,
			// url:`/system/area/${data}`,
			method:'get',
		})
	},
	editName(data){
		return request({
			baseURL:Config.remote(),
		    url:URL.editNameUrl,
			method:'post',
		    data
		})
	},
	unBindRule(data){
		return request({
			baseURL:Config.remote(),
		    url:URL.unBindRuleUrl,
			method:'post',
		    data
		})
	},
	//add
	bindRule(data){
		return request({
			baseURL:Config.remote(),
		    url:URL.bindRuleUrl,
			method:'post',
		    data
		})
	},
	queryBindRule(data){
		return request({
			baseURL:Config.remote(),
		    url:URL.queryBindRuleUrl,
			method:'get',
			params:data
		})
	},
	
	editDreamLight(data){
		return request({
		    baseURL:Config.remote(),
		    url:URL.DreamLightUptUrl,
		    method:'put',
			data
		})
	},
	deleteDreamLight(data){
		return request({
		    baseURL:Config.remote(),
		    url:URL.DreamLightRemUrl,
		    method:'delete',
			params:data
		})
	},
	getDreamLightCategoriesData(){
		return request({
		    baseURL:Config.remote(),
		    url:URL.DreamLightCategoriesUrl,
		    method:'get',
		})
	},
	getDreamLightMode(){
		return request({
		    baseURL:Config.remote(),
		    url:URL.DreamLightMode,
		    method:'get',
		})
	},
	addDreamLight(data){
		return request({
		    baseURL:Config.remote(),
		    url:URL.DreamLightAddUrl,
			method:'post',
			data
		})
	},
	//041
	editDreamLightV2(data){
		return request({
		    baseURL:Config.remote(),
		    url:URL.DreamLightUptUrlV2,
		    method:'put',
			data
		})
	},
	deleteDreamLightV2(data){
		return request({
		    baseURL:Config.remote(),
		    url:URL.DreamLightRemUrlV2,
		    method:'delete',
			params:data
		})
	},
	getDreamLightCategoriesDataV2(){
		return request({
		    baseURL:Config.remote(),
		    url:URL.DreamLightCategoriesUrlV2,
		    method:'get',
		})
	},
	getDreamLightModeV2(){
		return request({
		    baseURL:Config.remote(),
		    url:URL.DreamLightModeV2,
		    method:'get',
		})
	},
	addDreamLightV2(data){
		return request({
		    baseURL:Config.remote(),
		    url:URL.DreamLightAddUrlV2,
			method:'post',
			data
		})
	},
	//041
	//022ct
	getDreamLightCategoriesDataV3(){
		return request({
		    baseURL:Config.remote(),
		    url:URL.DreamLightCategoriesUrlV3+`?version=3`,
		    method:'get',
		})
	},
	getDreamLightModeV3(){
		return request({
		    baseURL:Config.remote(),
		    url:URL.DreamLightModeV3,
		    method:'get',
		})
	},
	addDreamLightV3(data){
		return request({
		    baseURL:Config.remote(),
		    url:URL.DreamLightAddUrlV3,
			method:'post',
			data
		})
	},
	editDreamLightV3(data){
		return request({
		    baseURL:Config.remote(),
		    url:URL.DreamLightUptUrlV3,
		    method:'put',
			data
		})
	},
	deleteDreamLightV3(data){
		return request({
		    baseURL:Config.remote(),
		    url:URL.DreamLightRemUrlV3,
		    method:'delete',
			params:data
		})
	},
	//022ct end
    login:(data)=>{
        return request({
            baseURL:Config.remote+'v2',
            url:URL.Login,
            method:'post',
            data
        })
    },
    getDeviceList:()=>{
        return request({
            baseURL:Config.remote()+'v2',
            url:URL.GetDeviceList,
            method:'post',
        })
    },
    getSingleDeviceInfo:(data)=>{
        return request({
            baseURL:Config.remote()+'v2',
            url:URL.GetSingleDeviceInfo,
            method:'post',
            data
        })
    },
    devicePropertiesSet:(data)=>{
        return request({
            baseURL:Config.remote(),
            url:"/api-device/device/set/property",
            method:'put',
            data
        })
    },
	
	deviceDetail:(deviceId)=>{
		return request({
		    baseURL:Config.remote(),
		    url:`/api-device/device/${deviceId}`,
		    method:'get',
		})
	},
	
	
	
    devicePropertiesGet:(deviceId)=>{
        return request({
            baseURL:Config.remote(),
            url:`/api-device/device/${deviceId}/model`,
            method:'get',
        })
    },
	//获取某个区域场景信息
	GetSceneListByRoomID(data){
		return request({
			baseURL:Config.remote(),
			url:URL.GetSceneListByRoomID,
			method:'get',
			params:data
		})
	},
	
    getAllSceneInfo(data){
        return request({
            baseURL:Config.remote()+'v2',
            url:URL.GetAllSceneInfo,
            method:'post',
            data
        })
    },
    bindScene(data){
        return request({
            baseURL:Config.remote()+'v2',
            url:URL.SceneBind,
            method:'post',
            data
        })
    },
	//edit
    performScene(data){
        return request({
            baseURL:Config.remote(),
            url:URL.SceneExecute+'?ruleId='+data,
            method:'post',
        })
    },
    resetDevice(data) {
        return request({
            baseURL:Config.remote()+'v2',
            url:URL.DeviceReset,
            method:'post',
            data
        })
    }
}
export {Api}

const Actions  = {
	getArea:(data)=>{
		return new Promise((resolve,reject)=>{
			Api.getArea(data).then(response=>{
				resolve(response.data);
			}).catch(error=>{
			    reject(error);
			})
		})
	},
	editName:(data)=>{
		return new Promise((resolve,reject)=>{
			Api.editName(data).then(response=>{
				resolve(response.data);
			}).catch(error=>{
			    reject(error);
			})
		})
	},
	unBindRule:(data)=>{
		return new Promise((resolve,reject)=>{
			Api.unBindRule(data).then(response=>{
				resolve(response.data);
			}).catch(error=>{
			    reject(error);
			})
		})
	},
	bindRule:(data)=>{
		return new Promise((resolve,reject)=>{
			Api.bindRule(data).then(response=>{
				resolve(response.data);
				
			}).catch(error=>{
			    reject(error);
			})
		})
	},
	queryBindRule:(data)=>{
		return new Promise((resolve,reject)=>{
			Api.queryBindRule(data).then(response=>{
				resolve(response.data);
			}).catch(error=>{
			    reject(error);
			})
		})
	},
	uptDreamLight:(data)=>{
		return new Promise((resolve,reject)=>{
			Api.editDreamLight(data).then(response=>{
				resolve(response.data);
			}).catch(error=>{
			    reject(error);
			})
		})
	},
	
	remDreamLight:(data)=>{
		return new Promise((resolve,reject)=>{
			Api.deleteDreamLight(data).then(response=>{
				resolve(response.data);
			}).catch(error=>{
			    reject(error);
			})
		})
	},
	addDreamLightData:(data)=>{
		return new Promise((resolve,reject)=>{
			Api.addDreamLight(data).then(response=>{
				resolve(response.data);
			}).catch(error=>{
			    reject(error);
			})
		})
	},
	
	
	DreamLightCategoriesData:()=>{
		return new Promise((resolve,reject)=>{
			Api.getDreamLightCategoriesData().then(response=>{
				resolve(response.data);
				
			}).catch(error=>{
			    reject(error);
			})
		})
	},
	DreamLightModes:()=>{
		return new Promise((resolve,reject)=>{
			Api.getDreamLightMode().then(response=>{
				resolve(response.data);
			}).catch(error=>{
			    reject(error);
			})
		})
	},
	
	
	//spi
	uptDreamLightV2:(data)=>{
		return new Promise((resolve,reject)=>{
			Api.editDreamLightV2(data).then(response=>{
				resolve(response.data);
			}).catch(error=>{
			    reject(error);
			})
		})
	},
	
	remDreamLightV2:(data)=>{
		return new Promise((resolve,reject)=>{
			Api.deleteDreamLightV2(data).then(response=>{
				resolve(response.data);
			}).catch(error=>{
			    reject(error);
			})
		})
	},
	addDreamLightDataV2:(data)=>{
		return new Promise((resolve,reject)=>{
			Api.addDreamLightV2(data).then(response=>{
				resolve(response.data);
			}).catch(error=>{
			    reject(error);
			})
		})
	},
	
	
	
	//spi
	DreamLightCategoriesDataV2:()=>{
		return new Promise((resolve,reject)=>{
			Api.getDreamLightCategoriesDataV2().then(response=>{
				resolve(response.data);
				
			}).catch(error=>{
			    reject(error);
			})
		})
	},
	DreamLightModesV2:()=>{
		return new Promise((resolve,reject)=>{
			Api.getDreamLightModeV2().then(response=>{
				resolve(response.data);
			}).catch(error=>{
			    reject(error);
			})
		})
	},
	uptDreamLightV3:(data)=>{
		return new Promise((resolve,reject)=>{
			Api.editDreamLightV3(data).then(response=>{
				resolve(response.data);
			}).catch(error=>{
			    reject(error);
			})
		})
	},
	remDreamLightV3:(data)=>{
		return new Promise((resolve,reject)=>{
			Api.deleteDreamLightV3(data).then(response=>{
				resolve(response.data);
			}).catch(error=>{
			    reject(error);
			})
		})
	},
	addDreamLightDataV3:(data)=>{
		return new Promise((resolve,reject)=>{
			Api.addDreamLightV3(data).then(response=>{
				resolve(response.data);
			}).catch(error=>{
			    reject(error);
			})
		})
	},
	DreamLightCategoriesDataV3:()=>{
		return new Promise((resolve,reject)=>{
			Api.getDreamLightCategoriesDataV3().then(response=>{
				resolve(response.data);
				
			}).catch(error=>{
			    reject(error);
			})
		})
	},
	DreamLightModesV3:()=>{
		return new Promise((resolve,reject)=>{
			Api.getDreamLightModeV3().then(response=>{
				resolve(response.data);
			}).catch(error=>{
			    reject(error);
			})
		})
	},
    /**
     * 用户登陆
     * @param {用户名} username 
     * @param {密码} password 
     * @returns 
     */
    login:(username,password)=>{
        return new Promise((resolve,reject)=>{
            Api.login({name:username,password:password}).then(response=>{
                resolve(response.data);
            }).catch(error=>{
                reject(error);
            })
        })
    },
    /**
     * 获取设备列表
     * @returns 
     */
    getDeviceList:()=>{
        return new Promise((resolve,reject)=>{
            Api.getDeviceList().then(response=>{
                resolve(response.data);
            }).catch(error=>{
                reject(error);
            })
        })
    },
    /**
     * 获取单设备信息
     * @param {mac} mac 
     * @returns 
     */
    getSingleDeviceInfo:(mac)=>{
        return new Promise((resolve,reject)=>{
            Api.getSingleDeviceInfo({Mac:mac}).then(response=>{
                resolve(response.data);
            }).catch(error=>{
                reject(error);
            })
        })
    },
    /**
     * 操作设备属性
     * @param {deviceId} deviceId 
     * @param {属性集} properties 
     * @returns 
     */
    devicePropertiesSet:(deviceId,properties)=>{
        return new Promise((resolve,reject)=>{
            Api.devicePropertiesSet({deviceId:deviceId,thingProperties:JSON.stringify(properties)}).then(response=>{
				resolve(response.data);
                if(response.data && response.data.code != 200){
                    return toast.show(response.data.code+","+response.data.msg);
                }
               
            }).catch(error=>{
                reject(error);
            })
        })
    },
    /**
     * 设备属性读操作
     * @param {设备id} deviceId 
     * @returns 
     */
    devicePropertiesGet:(deviceId)=>{
        return new Promise((resolve,reject)=>{
            Api.devicePropertiesGet(deviceId).then(response=>{
                resolve(response.data);
            }).catch(error=>{
                reject(error);
            })
        })
    },
	
	
	
	
	deviceDetail:(deviceId)=>{
		return new Promise((resolve,reject)=>{
		    Api.deviceDetail(deviceId).then(response=>{
		        resolve(response.data);
		    }).catch(error=>{
		        reject(error);
		    })
		})
	},
    /**
     * 获取所有场景信息
     * @returns 
     */
    getAllSceneInfo:() => {
        return new Promise((resolve,reject)=>{
            Api.getAllSceneInfo().then(response=>{
            if(response && response.data){
                    let resp = response.data;
                    var sceneTotal = resp.Data['SceneNum'];
                    var sceneList = resp.Data['SceneInfo'];
                    if(sceneTotal == 0) {
                        // toast.show('场景为空');
                    } else {
                        let newSceneList = [];
                        for (let index = 0; index < sceneList.length; index++) {
                            const element = sceneList[index];
                            // logger.i(element.Name);
                            // logger.i(!(element.Name.startsWith('-sys-') || element.Name.startsWith('-1-')))
                            if(element.Type == 1 && !(element.Name.startsWith('-sys-') || element.Name.startsWith('-1-'))) {
                                if(element.Name.startsWith('-0-')){
                                     let s = element.Name.split('-');
                                     element.Name = s[s.length - 1];
                                }
                                newSceneList.push(element);
                            }
                        }
                        resp.Data['SceneInfo'] = newSceneList;
                    }
            }
                resolve(response.data)
            }).catch(error=>{
                reject(error)
            })
        })
    },
	
	/*
	 获取某个区域场景信息
	*/
	GetSceneListByRoomID:(data) => {
	    return new Promise((resolve,reject)=>{
	        Api.GetSceneListByRoomID(data).then(response=>{
	            resolve(response.data)
				
	        }).catch(error=>{
	            reject(error)
	        })
	    })
	},
    /**
     * 场景面板按键绑定场景
     * @param {场景面板mac} mac 
     * @param {场景面板key索引} keyIndex 
     * @param {场景id} sceneId 
     * @returns 
     */
    bindSceneToPanelKey:(mac,keyIndex,sceneId)=>{
        return new Promise((resolve,reject)=>{
            Api.bindScene({Mac:mac,BindInfo:[{KeyIndex:keyIndex,SceneID:sceneId}]}).then(response=>{
                if(response.code != 200){
                   return toast.show(response.data.code+","+response.data.msg);
                }
                resolve(response.data);
            }).catch(error=>{
                reject(error);
            })
        })
    },
    /**
     * 执行场景
     * @param {场景id} sceneId 
     * @returns 
     */
    performScene:(ruleId)=>{
        return new Promise((resolve,reject)=>{
            Api.performScene(ruleId).then(response=>{
                if(response.data && response.data.code != 200){
                   return toast.show(response.data.code+","+response.data.msg);
                }
                resolve(response.data);
            }).catch(error=>{
                reject(error);
            })
        })
    },
    // /**
    //  * 操作设备属性
    //  * @param {mac} mac 
    //  * @param {属性集} properties 
    //  * @returns 
    //  */
    //  devicePropertiesSet2:(mac,properties,success,failed)=>{
    //     Api.devicePropertiesSet({Action:'APP',Params:{Mac:mac,Data:properties}}).then(response=>{
    //         if(response.status == 200){
    //             if(response.data.Code == 0) {
    //                 if(success) {
    //                     success(response.data.Data);
    //                 }
    //             } else {
    //                 if(failed){
    //                     failed(response.data.Code,response.data.Message);
    //                 }
    //             }
    //         }
    //     }).catch(error=>{
    //         logger.e('['+error.status+']'+error);
    //         if(failed){
    //             failed(error.status,error);
    //         }
    //     })
    // },
    resetDevice(mac){
        return new Promise((resolve,reject)=>{
            Api.resetDevice({Mac:mac}).then(response=>{
                if(response.data && response.data.Code != 0){
                    toast.show(response.data.code+","+response.data.msg);
                 }
                 resolve(response.data);
            }).catch(error=>{
                reject(error);
            })
        })
    }
}

export {Actions}

export default Actions;

const SetProperty = (deviceId,property,value)=>{
    let data = {};
    if(property == 'RGB') {
        var rgba = colorUtil.hexToRgb(value);
        data['R'] = rgba['r'];
        data['G'] = rgba['g'];
        data['B'] = rgba['b'];
    } else {
        data[property] = value;
    }
    return new Promise((resolve,reject)=>{
        Actions.devicePropertiesSet(deviceId,data).then(resp=>{
            resolve(resp);
        }).catch(error=>{
            reject(error);
        })
    })
}
export {SetProperty}

/**
 * 开关设置
 * @param {mac} mac 
 * @param {值} value 
 * @returns 
 */
const Switch = (mac,value)=>{
    return SetProperty(mac,"Switch",value ? 1 : 0);
}
export {Switch}

/**
 * 亮度设置
 * @param {mac} mac 
 * @param {值} value 
 * @returns 
 */
const Brightness = (mac,value)=>{
    return SetProperty(mac,"Brightness",value);
}
export {Brightness}

/**
 * 色温设置
 * @param {mac} mac 
 * @param {值} value 
 * @returns 
 */
const ColorTemperature = (mac,value)=>{
    return SetProperty(mac,"CCT",value);
}
export {ColorTemperature}

/**
 * 彩色灯光调节
 * @param {mac} mac 
 * @param {红色值} r 
 * @param {绿色值} g 
 * @param {蓝色值} b 
 * @returns 
 */
const RGB = (mac,r,g,b)=>{
    return Actions.devicePropertiesSet(mac,{R:r,G:g,B:b})
}
export {RGB}

/**
 * 窗帘开合状态
 * @param {mac} mac 
 * @param {0:关闭 1:打开 2:暂停} value 
 * @returns 
 */
const Mode = (mac,value)=>{
    return SetProperty(mac,"Mode",value);
}
export {Mode}

const setCookie = (data)=>{
	return request({
		baseURL:Config.remote(),
		url:URL.setLanguage,
		method:'get',
		params:data
	})
}
export {setCookie}
